import { CInputGroupText } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarInputGroupText = (props) => {
  const { children } = props
  return <CInputGroupText {...props}>{children}</CInputGroupText>
}

export { ConfiaCarInputGroupText }
